import e from"styled-components";var o=e.div.withConfig({componentId:"sc-4vbg19-0"})(["display:flex;align-items:center;"]);export{o as InputSuffixStyled};
